import { Injectable } from "@angular/core";
import { ajax } from "jquery";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
declare var WURFL: any;
import {
  FingerSDK,
  SdkOptionsType as FingerSdkOptionType,
  TransactionMode as FingerTransactionMode,
  Template as FingerTemplate,
  AsThreshold as FingerAsThreshold,
  FingerDetectionMode,
} from "@identy/identy-finger";
import { ContextMenuHelperService } from "./components/title-bar/title-context-menu/context-menu-helper.service";
import { ProgressDialog } from "./components/sdk-run/progress_dialog_renderer";
import { environment } from "src/environments/environment";
import { SpoofDialogComponent } from "./components/dialogs/spoof-dialog/spoof-dialog.component";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })

/**
 * Auth-service Component
 */
export class SdkService {
  isLocalhost =
    window.location.origin.includes("localhost") ||
    window.location.origin.includes("192.16");
  username = this.isLocalhost ? "localhost" : null;
  constructor(
    private contextMenuSelection: ContextMenuHelperService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {}

  progress_dialog_ref: ProgressDialog;
  finger_sdk: FingerSDK;

  isRunning = false;
  bsModalTxnRef: BsModalRef;
  // selectedFinger: any;
  // no_face: BsModalRef;
  protected delay = (millis) =>
    new Promise<void>((resolve, reject) => {
      setTimeout((_) => resolve(), millis);
    });
  ngOnInit() {}

  // async capture_finger(selectedFinger) {
  async capture_finger() {
    // this.selectedFinger = selectedFinger;
    let finger_capture: any = await this.run_till_capture_finger();
    return finger_capture;
  }

  async run_till_capture_finger() {
    // await this.finger_promise;
    return new Promise((resolve, reject) => {
      return this.run_capture_finger()
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          const ref = this.modalService.show(SpoofDialogComponent, {
            class: "modal-dialog-centered modal-sm txn-modal-dialog",
            initialState: {
              onclose: () => {
                ref.hide();
                resolve(void 0);
              },
              onretry: () => {
                ref.hide();
                this.run_till_capture_finger().then((cap_response) => {
                  resolve(cap_response);
                });
              },
            },
          });
        });
    });
  }

  async run_capture_finger() {
    await this.initialize_finger();
    const finger_blob = await this.finger_sdk.capture();
    return this.post_data(finger_blob);
  }

  async initialize_finger() {
    if (this.finger_sdk) {
      return Promise.resolve();
    }

    let pdx: any;
    let ctx = this;
    const delay = (millis) =>
      new Promise<void>((resolve, reject) => {
        setTimeout((_) => resolve(), millis);
      });

    const options: FingerSdkOptionType = {
      enableAS: true,
      calculateNFIQ: true,
      asThreshold: FingerAsThreshold.HIGH,
      requiredTemplates: [],
      showCaptureTraining: true,
      captureTimeout: 300000,
      skipSupportCheck: false,
      showOrientationDialog: true,
      showNextHandSelection: true,
      //debug: true,
      transaction: {
        type: FingerTransactionMode.CAPTURE,
      },
      events: {
        onDebugFlashCaptured(size) {
          ctx.toastr.show(`Captured Size: ${size.width}x${size.height}`);
        },
        onNoFlashDetected() {
          alert(
            "Browser doesn't support flash, please be in good lighting for an optimal capture"
          );
        },
        // onQualityCheckComplete: async (
        //   qinfo: Array<any>,
        //   fFailure: boolean
        // ) => {
        //   await delay(300);

        //   for (const qinfoElement of qinfo) {
        //     ctx.toastr.show(
        //       `Quality ${
        //         qinfoElement.name.name
        //       }: ${qinfoElement.quality.toFixed(3)}`
        //     );
        //   }
        //   if (!fFailure) {
        //     ctx.toastr.show(`4F Failure`);
        //   }

        //   setTimeout(() => {
        //     if (pdx) {
        //       pdx.hide();
        //     }
        //   }, 10);
        // },
      },
      // slidingFingers: selection.slidingFingers,
      detectionModes: [
        FingerDetectionMode.L4F,
        FingerDetectionMode.R4F,
        FingerDetectionMode.LEFT_THUMB,
        FingerDetectionMode.RIGHT_THUMB,
      ],
      // detectionModes: [
      //   this.selectedFinger == "L4F"
      //     ? FingerDetectionMode.L4F
      //     : this.selectedFinger == "R4F"
      //     ? FingerDetectionMode.R4F
      //     : this.selectedFinger == "LThumb"
      //     ? FingerDetectionMode.LEFT_THUMB
      //     : this.selectedFinger == "RThumb"
      //     ? FingerDetectionMode.RIGHT_THUMB
      //     : FingerDetectionMode.RIGHT_THUMB,
      //   // FingerDetectionMode.R4F,
      //   // FingerDetectionMode.LEFT_THUMB,
      //   // FingerDetectionMode.RIGHT_THUMB,
      // ],
    };

    // not exposed field just for testing
    options["enableGImage"] = true;

    this.finger_sdk = new FingerSDK(options);
    return this.finger_sdk.initialize();
  }

  post_data(capresult: Blob, show_progress: boolean = true) {
    return new Promise((resolve, reject) => {
      if (show_progress) {
        this.progress_dialog_ref?.hide();
        this.progress_dialog_ref = new ProgressDialog("Processing", true);
      }

      const fd = new FormData();
      fd.append("file", capresult, `bdata`);
      ajax({
        url: `${
          environment.finger_url
        }/api/v1/process?ts=${new Date().getTime()}`,
        contentType: false,
        processData: false,
        method: "POST",
        dataType: "JSON",
        data: fd,
        headers: {
          "X-DEBUG": this.username,
        },
      })
        .done((response: any) => {
          this.progress_dialog_ref?.hide();
          console.log("POST: RESPONSE");
          if (response.code !== 200) {
            return reject(response);
          }
          return resolve(response);
        })
        .fail((err) => {
          this.progress_dialog_ref?.hide();
          return reject(err);
        });
    });
  }
}
